import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormData } from '../types';
import { Questionnaire } from '../components/Questionnaire';
import { questionnaire } from '../questionnaire/questionnaire';

const HomePage = () => {
  const navigate = useNavigate();

  // Initialize form data
  const [formData, setFormData] = useState<FormData>({ crossBorderConsent: false });

  const handleFormSubmit = async (data: FormData) => {
    try {
      // Validate required fields
      if (!data.companyName || !data.privacyConsent) {
        throw new Error('Company name and privacy consent are required');
      }

      // Send to backend
      const response = await fetch('/api/submissions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Submission failed');
      }

      // Success
      navigate('/success');

    } catch (error) {
      console.error('Submission error:', error);
      // Show error to user
      alert('We could not submit your assessment. Please try again.');
    }
  };

  return (
    <div className="main-content">
      <div className="container">
        <div className="form-container">
          <h1>China Readiness Check</h1>
          <p className="form-intro">
            Understanding your current China setup helps us identify the areas that deserve a closer look.
            The China Readiness Check takes only a few minutes and gives us a structured overview of your company's
            current activities, plans and challenges in China.
          </p>

          <Questionnaire
            sections={questionnaire.sections}
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleFormSubmit}
          />

        </div>
      </div>
    </div>
  );
};

export default HomePage;
